import type { ThemeColors } from '@pink/shared';

/**
 * Schreibt die `themeColors` der Tenant-Config als CSS-Variablen ans
 * gegebene Root-Element. Tailwind referenziert sie über
 * `theme.extend.colors`.
 *
 * Fehlende optionale Felder werden nicht überschrieben — die Defaults aus
 * `src/index.css` bleiben so unverändert. Beim Tenant-Wechsel entfernen wir
 * einen zuvor gesetzten `--brand-foreground`, damit der CSS-Default
 * (`var(--color-background)`) wieder greift, wenn der neue Tenant kein
 * `textOnPrimary` mitbringt.
 *
 * @param colors      Themefarben aus `TenantConfig`.
 * @param rootElement Ziel-Element (üblicherweise `document.documentElement`).
 */
export function applyTheme(colors: ThemeColors, rootElement: HTMLElement): void {
  rootElement.style.setProperty('--color-primary', colors.primary);
  if (colors.secondary !== undefined) {
    rootElement.style.setProperty('--color-secondary', colors.secondary);
  }
  if (colors.background !== undefined) {
    rootElement.style.setProperty('--color-background', colors.background);
  }
  if (colors.text !== undefined) {
    rootElement.style.setProperty('--color-text', colors.text);
  }
  if (colors.textOnPrimary !== undefined) {
    rootElement.style.setProperty('--brand-foreground', colors.textOnPrimary);
  } else {
    rootElement.style.removeProperty('--brand-foreground');
  }
}
